import React from 'react';
import { Button } from 'antd';
import { CloseOutlined } from '@ant-design/icons';

// Helper function to format numbers to 2 decimal places
const formatNumber = (value) => {
  if (value === undefined || value === null) return '0';
  const num = parseFloat(value);
  if (isNaN(num)) return value;
  return Number.isInteger(num) ? num.toString() : num.toFixed(2);
};

const ControlloOndeVerde = ({ result, setResult, visible = true }) => {
  // Only show when we have results and visible is true
  if (!visible || ((!result.offset_coppie || result.offset_coppie.length === 0) &&
      (!result.risultati || result.risultati.length === 0))) {
    return null;
  }

  return (
    <div
      style={{
        position: 'fixed',
        top: '180px',
        right: '20px',
        width: '380px',
        background: 'white',
        borderRadius: '12px',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.12)',
        zIndex: 1004,
        display: 'flex',
        flexDirection: 'column',
        maxHeight: 'calc(100vh - 200px)'
      }}
    >
      {/* Card Header */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '16px 20px',
        borderBottom: '1px solid #f0f0f0',
        background: 'linear-gradient(135deg, #fafafa 0%, #ffffff 100%)'
      }}>
        <div style={{
          fontSize: '16px',
          fontWeight: '600',
          color: '#1a1a1a'
        }}>
          Controllo dell'Onda Verde
        </div>
        <Button
          type="text"
          icon={<CloseOutlined style={{ color: '#999', fontSize: '14px' }} />}
          onClick={() => setResult({ offset_coppie: [], risultati: [] })}
          style={{
            padding: 0,
            width: 24,
            height: 24,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        />
      </div>

      {/* Card Body */}
      <div style={{
        flex: 1,
        overflowY: 'auto',
        overflowX: 'hidden'
      }}>
        {/* Section 1: Offset Coppie */}
        {result.offset_coppie && result.offset_coppie.length > 0 && (
          <div style={{
            padding: '16px 20px',
            borderBottom: result.risultati && result.risultati.length > 0 ? '1px solid #f0f0f0' : 'none'
          }}>
            <div style={{
              fontSize: '13px',
              fontWeight: '600',
              color: '#A1E430',
              marginBottom: '12px',
              textTransform: 'uppercase',
              letterSpacing: '0.5px'
            }}>
              Offset Coppie
            </div>

            {result.offset_coppie.map((coppia, index) => {
              // Parse the coppia string which is in format "id1->id2"
              let fromId, toId;
              if (coppia.coppia && coppia.coppia.includes('->')) {
                const parts = coppia.coppia.split('->');
                fromId = parts[0];
                toId = parts[1];
              } else {
                fromId = coppia.from_id || coppia.from || coppia.semaforo_A || '';
                toId = coppia.to_id || coppia.to || coppia.semaforo_B || '';
              }

              // Get the offset value (offset_ottimale or travel_time)
              const offsetValue = coppia.offset_ottimale !== undefined
                ? coppia.offset_ottimale
                : (coppia.travel_time || coppia.tempo_viaggio || 0);

              return (
                <div
                  key={index}
                  style={{
                    marginBottom: index < result.offset_coppie.length - 1 ? '20px' : '0',
                    paddingBottom: index < result.offset_coppie.length - 1 ? '20px' : '0',
                    borderBottom: index < result.offset_coppie.length - 1 ? '1px solid #f5f5f5' : 'none'
                  }}
                >
                  {/* Traffic Light IDs Row */}
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginBottom: '12px'
                  }}>
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '16px',
                      flex: 1
                    }}>
                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px'
                      }}>
                        {/* Traffic Light Icon */}
                        <div style={{
                          width: '18px',
                          height: '32px',
                          background: '#333',
                          borderRadius: '4px',
                          padding: '2px',
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          justifyContent: 'center',
                          gap: '2px'
                        }}>
                          <div style={{
                            width: '6px',
                            height: '6px',
                            borderRadius: '50%',
                            background: '#ff4444'
                          }} />
                          <div style={{
                            width: '6px',
                            height: '6px',
                            borderRadius: '50%',
                            background: '#ffaa00'
                          }} />
                          <div style={{
                            width: '6px',
                            height: '6px',
                            borderRadius: '50%',
                            background: '#44ff44'
                          }} />
                        </div>
                        <span style={{
                          fontSize: '13px',
                          fontWeight: '500',
                          color: '#333'
                        }}>
                          {fromId}
                        </span>
                      </div>

                      <span style={{
                        fontSize: '18px',
                        color: '#ccc'
                      }}>
                        →
                      </span>

                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px'
                      }}>
                        {/* Traffic Light Icon */}
                        <div style={{
                          width: '18px',
                          height: '32px',
                          background: '#333',
                          borderRadius: '4px',
                          padding: '2px',
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          justifyContent: 'center',
                          gap: '2px'
                        }}>
                          <div style={{
                            width: '6px',
                            height: '6px',
                            borderRadius: '50%',
                            background: '#ff4444'
                          }} />
                          <div style={{
                            width: '6px',
                            height: '6px',
                            borderRadius: '50%',
                            background: '#ffaa00'
                          }} />
                          <div style={{
                            width: '6px',
                            height: '6px',
                            borderRadius: '50%',
                            background: '#44ff44'
                          }} />
                        </div>
                        <span style={{
                          fontSize: '13px',
                          fontWeight: '500',
                          color: '#333'
                        }}>
                          {toId}
                        </span>
                      </div>
                    </div>

                    <div style={{
                      fontSize: '14px',
                      fontWeight: '600',
                      color: '#333'
                    }}>
                      {formatNumber(offsetValue)}s
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}

        {/* Section 2: Risultati */}
        {result.risultati && result.risultati.length > 0 && (
          <div style={{
            padding: '16px 20px',
            paddingBottom: '24px'
          }}>
            <div style={{
              fontSize: '13px',
              fontWeight: '600',
              color: '#A1E430',
              marginBottom: '12px',
              textTransform: 'uppercase',
              letterSpacing: '0.5px'
            }}>
              Risultati Semafori
            </div>

            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '12px'
            }}>
              {result.risultati.map((semaforo, index) => (
                <div
                  key={index}
                  style={{
                    background: '#f8f8f8',
                    borderRadius: '8px',
                    padding: '12px',
                    border: '1px solid #e8e8e8'
                  }}
                >
                  {/* Semaforo Header */}
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                    marginBottom: '8px'
                  }}>
                    <div style={{
                      width: '20px',
                      height: '36px',
                      background: '#333',
                      borderRadius: '5px',
                      padding: '3px',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '3px'
                    }}>
                      <div style={{
                        width: '7px',
                        height: '7px',
                        borderRadius: '50%',
                        background: '#ff4444'
                      }} />
                      <div style={{
                        width: '7px',
                        height: '7px',
                        borderRadius: '50%',
                        background: '#ffaa00'
                      }} />
                      <div style={{
                        width: '7px',
                        height: '7px',
                        borderRadius: '50%',
                        background: '#44ff44'
                      }} />
                    </div>
                    <div style={{
                      flex: 1
                    }}>
                      <div style={{
                        fontSize: '14px',
                        fontWeight: '600',
                        color: '#333'
                      }}>
                        {semaforo.semaforo || semaforo.nome || `Semaforo ${index + 1}`}
                      </div>
                      <div style={{
                        fontSize: '12px',
                        color: '#666'
                      }}>
                        ID: {semaforo.id || index + 1}
                      </div>
                    </div>
                  </div>

                  {/* Details Grid */}
                  <div style={{
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr',
                    gap: '8px',
                    fontSize: '11px',
                    lineHeight: '18px'
                  }}>
                    <div>
                      <span style={{ color: '#999' }}>Distanza: </span>
                      <span style={{ color: '#333', fontWeight: '500' }}>
                        {formatNumber(semaforo.distanza)}m
                      </span>
                    </div>
                    <div>
                      <span style={{ color: '#999' }}>Durata verde: </span>
                      <span style={{ color: '#52c41a', fontWeight: '500' }}>
                        {formatNumber(semaforo.durata_verde)}s
                      </span>
                    </div>
                    <div>
                      <span style={{ color: '#999' }}>Inizio verde: </span>
                      <span style={{ color: '#333', fontWeight: '500' }}>
                        {formatNumber(semaforo.inizio_verde)}s
                      </span>
                    </div>
                    <div>
                      <span style={{ color: '#999' }}>Fine verde: </span>
                      <span style={{ color: '#333', fontWeight: '500' }}>
                        {formatNumber(semaforo.fine_verde)}s
                      </span>
                    </div>
                    <div>
                      <span style={{ color: '#999' }}>Tempo arrivo: </span>
                      <span style={{ color: '#ff4444', fontWeight: '500' }}>
                        {formatNumber(semaforo.tempo_arrivo)}s
                      </span>
                    </div>
                    <div>
                      <span style={{ color: '#999' }}>Tempo uscita: </span>
                      <span style={{ color: '#52c41a', fontWeight: '500' }}>
                        {formatNumber(semaforo.tempo_uscita)}s
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ControlloOndeVerde;